"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const taskWidget_1 = __importDefault(require("./taskWidget"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const TaskListProgress = ({ setupItems, open, onOpenToggle, onClick, titleOnTop, name, selected }) => {
    const { classes } = useStyles();
    const rootClassname = (0, classnames_1.default)(classes.root, { closed: !open }, { [classes.rootDashboardHeight]: !titleOnTop }, { [classes.modalRootOverwrite]: titleOnTop });
    return (<div style={{ textAlign: 'center', marginLeft: 16, marginRight: 16 }}>
      {onOpenToggle &&
            <ButtonBase_1.default onClick={(e) => onOpenToggle(e, !open)} className={classes.toggleButton}>
          <div className={classes.toggleSwitch}/>
        </ButtonBase_1.default>}
      <div id={`${name || 'default'}-setup-task-bar`} className={rootClassname}>
        {titleOnTop &&
            <div className={(0, classnames_1.default)(classes.title, 'ontop')}>
          <Typography_1.default className={classes.titleText}>
            SET UP YOUR QUICKEN CLASSIC
          </Typography_1.default>

        </div>}
        <div className={(0, classnames_1.default)(classes.container)}>
          {!titleOnTop &&
            <div className={classes.title}>
              <Typography_1.default className={classes.titleText}>
                SET UP YOUR QUICKEN CLASSIC
              </Typography_1.default>
            </div>}

          <div className={classes.widgetHolder}>
            {setupItems.map((x) => <taskWidget_1.default key={`task-widget-${x.name}`} title={x.title} completed={Boolean(x.completed)} selected={selected === x.name} onClick={onClick} name={x.name}/>)}
          </div>
        </div>
      </div>
    </div>);
};
exports.default = TaskListProgress;
